"use strict";module.exports=e=>e?e.map((e=>{var a;return Object.assign(Object.assign({},e),{thumbnailImages:(null===(a=null==e?void 0:e.thumbnailImages)||void 0===a?void 0:a.map((e=>({src:e.reference,alt:""}))))||[]})})):[];
//# sourceMappingURL=index.js.map
